import { ChangeDetectionStrategy, Component } from '@angular/core';

import { ClockComponent } from '../header/clock/clock.component';
import { LanguageSelectorComponent } from '../header/language-selector/language-selector.component';

/**
 * Minimal header for public, token-less pages (e.g. sign-up): just the NEXT logo, the language
 * selector and the UTC clock. Unlike the main `HeaderComponent` it mounts no sidebar/user-menu, so it triggers no
 * authenticated calls — the reason the full header is hidden on those routes.
 */
@Component({
  selector: 'app-unlogged-header',
  standalone: true,
  imports: [LanguageSelectorComponent, ClockComponent],
  templateUrl: './unlogged-header.component.html',
  styleUrl: './unlogged-header.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UnloggedHeaderComponent {}
